KCVS.Views.ReportInvolvedEmployeeRowTable =
  template: JST['report_rows/involved_employee_rows_table']()

  mounted: ->
    @fetchInvolvedEmployeeRows()

  data: ->
    rows: []

  methods:
    fetchInvolvedEmployeeRows: ->
      $.ajax
        url: "/admin/project_partners/#{@.$root.projectPartnerId}/involved_employee_rows.json"
        method: 'GET'
        dataType: 'JSON'
        success: (data) =>
          @rows = data

    destroyRow: (row) ->
      arrayRow = _.find(@rows, (s_row) -> s_row.id == row.id )
      deletedRowIndex = _.indexOf(@rows, arrayRow)
      if deletedRowIndex >= 0
        @rows.splice(deletedRowIndex, 1)
